import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-767bf409"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-housing" }
const _hoisted_2 = { class: "service-housing__section wrapper service-housing__gallery-and-search" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "service-housing__section wrapper service-housing__info-and-results" }
const _hoisted_5 = {
  key: 0,
  class: "service-housing__result-wrapper"
}
const _hoisted_6 = {
  key: 0,
  class: "service-housing__button-wrapper"
}
const _hoisted_7 = {
  key: 0,
  class: "service-housing__section--scrollable service-housing__related-services"
}
const _hoisted_8 = { class: "service-housing__section--scrollable service-housing__related-services" }

import {
  useServiceMediaFileQuery,
  useServiceRelatedServicesQuery,
} from '@/queries/public/services'
import { usePublicServiceRelatedPartnerServicesQuery } from '@/queries/partnership'
import PhotoGallery from '@/components/public/PhotoGallery.vue'
import HousingAvailabilitySearch from '@/components/public/housing/HousingAvailabilitySearch.vue'
import HousingResultCard from '@/components/public/housing/HousingResultCard.vue'
import SubmitButton from '@/components/public/SubmitButton.vue'
import RelatedServices from '@/components/public/RelatedServices.vue'
import { useFetchCompanyPeriodAvailability } from '@/queries/public/services'
import {
  Availability,
  HousingAvailabilityPayload,
} from '@/models/public/order.model'
import { ref, reactive, computed, watch } from 'vue'
import { useOrderStore } from '@/store/order'
import {
  PeriodAvailability,
  RelatedService,
} from '@/models/public/service.model'
import { getValidationErrorData } from '@/utils/errors'
import { AdditionalServiceInformationWithQuantity } from './AdditionalServiceCard.vue'
import { FORMATS } from '@/enums/components'
import { useBreakpoints } from '@/composables/useBreakpoints'
import router from '@/router'
import { ROUTE_PATHS } from '@/router/public/paths'
import { storeToRefs } from 'pinia'
import { debounce } from 'lodash'
import { servicePublicDetailsCommonProps } from '@/enums/public'


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceHousing',
  props: {
  ...servicePublicDetailsCommonProps,
},
  setup(__props) {

const props = __props



const {
  isLoading: isMediaFileLoading,
  isError: isMediaFileError,
  data: serviceMediaFile,
} = useServiceMediaFileQuery(ref(props.serviceId), props.isPreview)

const {
  mutateAsync: fetchPeriodAvailability,
  isLoading: isLoadingPeriodAvailability,
} = useFetchCompanyPeriodAvailability()

const { data: relatedServices } = useServiceRelatedServicesQuery(
  ref(props.serviceId),
  props.isPreview,
)

const { data: relatedPartnerServices } =
  usePublicServiceRelatedPartnerServicesQuery(
    ref(props.serviceId),
    props.isPreview,
  )

const orderStore = useOrderStore()
const errors = ref()
const { isMobile } = useBreakpoints()
const { order } = storeToRefs(orderStore)
const relatedAvailable = ref(null)
const periodAvailabilityList = ref<PeriodAvailability[]>([])
const searchParams = reactive<Partial<Availability>>({})
const availabilitySearchInSession = computed(() => {
  const searchInsession = sessionStorage.getItem('availiability-search-housing')
  return searchInsession ? JSON.parse(searchInsession) : null
})

const servicePeriodAvailability = ref<PeriodAvailability | undefined>()

const availabilityPayload = ref<HousingAvailabilityPayload>(
  availabilitySearchInSession.value
    ? { ...availabilitySearchInSession.value }
    : {
        check_in: null,
        check_out: null,
        adults: 1,
        children: 0,
      },
)

const updateAvailabilityPayload = (value: HousingAvailabilityPayload) => {
  availabilityPayload.value = value
  orderStore.updateHousingAvailabilitySearch(value)
}

const searchAvailability = async () => {
  errors.value = undefined
  updateAvailabilityPayload(availabilityPayload.value)

  fetchPeriodAvailability({
    company: props.service.company?.id,
    start: availabilityPayload.value.check_in,
    end: availabilityPayload.value.check_out,
  })
    .then((data) => {
      periodAvailabilityList.value = data
      servicePeriodAvailability.value = periodAvailabilityList.value?.find(
        (el) => el.service.id === props.service?.id,
      )
    })
    .catch((error) => {
      errors.value = getValidationErrorData(error)
    })
  Object.assign(searchParams, availabilityPayload.value)
}

const debouncedUpdateResultCard = debounce(searchAvailability, 400)

// If either is missing error would be returned. Happens when page opened with no previous search.
if (availabilityPayload.value.check_in && availabilityPayload.value.check_out) {
  searchAvailability()
}

const goToCart = () => {
  router.push({
    name: ROUTE_PATHS.CART,
    params: { uuid: order.value.uuid },
  })
}

const availableRelatedServiceList = computed<PeriodAvailability[]>(() => {
  return periodAvailabilityList.value.filter((housing: PeriodAvailability) => {
    return (
      housing.service.id !== props.service?.id &&
      !housing.is_min_advance_time_past &&
      housing.available_guests >=
        (searchParams.adults || 0) + (searchParams.children || 0)
    )
  })
})

const availableRelatedServiceServiceList = computed<RelatedService[]>(() => {
  return availableRelatedServiceList.value.map((item) => item.service)
})

const filteredRelatedServices = computed<RelatedService[]>(() => {
  const availableRelatedServiceIds = availableRelatedServiceList.value.map(
    (item) => item.service?.id,
  )
  const filtered =
    relatedServices.value?.filter(
      (service) => !availableRelatedServiceIds.includes(service.id),
    ) || []
  return filtered
})

const filteredRelatedPartnerServices = computed<RelatedService[]>(() => {
  // TODO: TOUR-552: Quick copy-paste logic of filteredRelatedServices without filtering.
  const availableRelatedServiceIds = availableRelatedServiceList.value.map(
    (item) => item.service?.id,
  )
  return relatedPartnerServices.value || []
})

watch(
  () => [
    availabilityPayload.value.check_in,
    availabilityPayload.value.check_out,
  ],
  () => {
    if (servicePeriodAvailability.value) {
      debouncedUpdateResultCard()
    }
  },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (
          !_unref(isMediaFileLoading) && !_unref(isMediaFileError) && _unref(serviceMediaFile)?.length
        )
        ? (_openBlock(), _createBlock(PhotoGallery, {
            key: 0,
            photos: _unref(serviceMediaFile)
          }, null, 8, ["photos"]))
        : _createCommentVNode("", true),
      (_ctx.enableOrdering)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(HousingAvailabilitySearch, {
              "model-value": availabilityPayload.value,
              service: _ctx.service,
              errors: errors.value,
              loading: _unref(isLoadingPeriodAvailability),
              "is-preview": _ctx.isPreview,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => updateAvailabilityPayload(value)),
              onSearch: searchAvailability
            }, null, 8, ["model-value", "service", "errors", "loading", "is-preview"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default"),
      (_ctx.enableOrdering && servicePeriodAvailability.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(HousingResultCard, {
              "period-availability": servicePeriodAvailability.value,
              "onUpdate:period-availability": _cache[1] || (_cache[1] = ($event: any) => ((servicePeriodAvailability).value = $event)),
              "availability-request": availabilityPayload.value,
              "onUpdate:availability-request": _cache[2] || (_cache[2] = ($event: any) => ((availabilityPayload).value = $event)),
              service: _ctx.service,
              "is-preview": _ctx.isPreview,
              "is-related-services": !!_unref(availableRelatedServiceList)?.length,
              errors: errors.value,
              "related-available-div": relatedAvailable.value,
              referral: _ctx.referral
            }, null, 8, ["period-availability", "availability-request", "service", "is-preview", "is-related-services", "errors", "related-available-div", "referral"]),
            (_unref(orderStore).isOrderWithItems && !_ctx.isPreview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(SubmitButton, {
                    format: _unref(FORMATS).PRIMARY,
                    label: _ctx.$t('goToCart'),
                    icon: "arrow-right",
                    "icon-right": true,
                    class: _normalizeClass(
              _unref(isMobile)
                ? 'service-page__button'
                : 'service-page__button--desktop'
            ),
                    onClick: _cache[3] || (_cache[3] = _withModifiers(() => goToCart(), ["prevent"]))
                  }, null, 8, ["format", "label", "class"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", {
      ref_key: "relatedAvailable",
      ref: relatedAvailable,
      class: "service-housing__section--scrollable service-housing__related-available-services"
    }, [
      (_unref(availableRelatedServiceList)?.length)
        ? (_openBlock(), _createBlock(RelatedServices, {
            key: 0,
            title: _ctx.$t('relatedAvailableServices.heading'),
            services: _unref(availableRelatedServiceServiceList),
            "is-preview": _ctx.isPreview,
            referral: {
          referral_type: 's',
          referral_code: _ctx.service.hash_id,
        }
          }, null, 8, ["title", "services", "is-preview", "referral"]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _unref(availableRelatedServiceList).length]
    ]),
    (!props.hideRelated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_unref(filteredRelatedServices)?.length)
            ? (_openBlock(), _createBlock(RelatedServices, {
                key: 0,
                title: _ctx.$t('relatedServices.heading'),
                services: _unref(filteredRelatedServices),
                "is-preview": _ctx.isPreview,
                referral: {
          referral_type: 's',
          referral_code: _ctx.service.hash_id,
        }
              }, null, 8, ["title", "services", "is-preview", "referral"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      (_unref(filteredRelatedPartnerServices)?.length)
        ? (_openBlock(), _createBlock(RelatedServices, {
            key: 0,
            title: _ctx.$t('relatedServices.partnersHeading'),
            services: _unref(filteredRelatedPartnerServices),
            "is-preview": _ctx.isPreview,
            referral: {
          referral_type: 's',
          referral_code: _ctx.service.hash_id,
        }
          }, null, 8, ["title", "services", "is-preview", "referral"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})